import { render, staticRenderFns } from "./ListIncidenteOtros.vue?vue&type=template&id=4e663d41&scoped=true&"
import script from "./ListIncidenteOtros.vue?vue&type=script&lang=js&"
export * from "./ListIncidenteOtros.vue?vue&type=script&lang=js&"
import style0 from "./ListIncidenteOtros.vue?vue&type=style&index=0&id=4e663d41&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e663d41",
  null
  
)

export default component.exports